// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3w1Sw","checkboxCol":"Table_checkboxCol__ojoip","emailCol":"Table_emailCol__1CGTO","actionCol":"Table_actionCol__D37oA"};